import { createSelector } from '@reduxjs/toolkit';

export const managersSelector = state => state.tickets.options.managers;
export const tagsSelector = state => state.tickets.options.tags;
export const skillGroupsSelector = state => state.tickets.options.skillGroups;

export const getManagerByIdSelector = id => state =>
  managersSelector(state).find(manager => manager.id === id);

export const managersByIdsSelector = createSelector(
  [managersSelector, (_, ids) => ids],
  (managers, ids) => managers.filter(manager => ids.includes(manager.id))
);
export const getSkillGroupByIdSelector = id => state =>
  skillGroupsSelector(state).find(skillGroup => skillGroup.value === id);

export const getTagByIdSelector = id => state =>
  tagsSelector(state).find(tag => tag.id === id);
